import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"; // Added HelpOutlineIcon

export default function NotificationSettings() {
  const [settings, setSettings] = useState({
    applied: true,
    phoneScreen: true,
    interview: true,
    hired: true,
    rejected: true,
    newJob: true,
    newJobApplication: true,
    newInterviewSchedule: true,
    newOfferLetter: true,
    notificationsToRecruiter: true,
  });

  const handleChange = (event) => {
    setSettings({
      ...settings,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSave = () => {
    console.log("Saved Settings:", settings);
    alert("Settings saved successfully!");
  };

  return (
    <Box
      sx={{
        padding: "20px",
        maxWidth: "100%",
        margin: "auto",
        textAlign: "left",
        fontFamily: "Arial, sans-serif",
        color: "black",
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "10px", fontWeight: "bold", fontSize: "20px" }}
      >
        Mail Settings
      </Typography>
      <Typography title="">
        Send mail when application status changes to these states
        <HelpOutlineIcon
          sx={{ marginLeft: "0px", cursor: "pointer", color: "black" }}
        />
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            name="applied"
            checked={settings.applied}
            sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
            onChange={handleChange}
          />
        }
        label="Applied"
      />
      <FormControlLabel
        control={
          <Checkbox
            name="phoneScreen"
            checked={settings.phoneScreen}
            sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
            onChange={handleChange}
          />
        }
        label="Phone Screen"
      />
      <FormControlLabel
        control={
          <Checkbox
            name="interview"
            checked={settings.interview}
            sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
            onChange={handleChange}
          />
        }
        label="Interview"
      />
      <FormControlLabel
        control={
          <Checkbox
            name="hired"
            checked={settings.hired}
            onChange={handleChange}
            sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
          />
        }
        label="Hired"
      />

      {/* <FormControlLabel
        control={
          <Checkbox
            checked={settings.hired}
            onChange={handleChange}
            sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
          />
        }
        label="Allow employee to request shift change"
        sx={{ width: "100%" }}
      /> */}

      <FormControlLabel
        control={
          <Checkbox
            name="rejected"
            checked={settings.rejected}
            sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
            onChange={handleChange}
          />
        }
        label="Rejected"
      />

      <Typography
        variant="h6"
        sx={{ marginTop: "20px", marginBottom: "10px", fontWeight: "bold" }}
      >
        Email Notification Settings
      </Typography>

      {/* Changed layout to flex-column for checkboxes under Email Notification Settings */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Ensures flex-column layout
        }}
      >
        {/* Added a black border to each checkbox */}
        <FormControlLabel
          control={
            <Checkbox
              name="newJob"
              checked={settings.newJob}
              onChange={handleChange}
              sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
            />
          }
          label="New Job (Added by Admin)"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="newJobApplication"
              checked={settings.newJobApplication}
              sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
              onChange={handleChange}
            />
          }
          label="New Job Application (Added by Admin)"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="newInterviewSchedule"
              checked={settings.newInterviewSchedule}
              sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
              onChange={handleChange}
            />
          }
          label="New Interview Schedule (Added by Admin)"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="newOfferLetter"
              checked={settings.newOfferLetter}
              sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
              onChange={handleChange}
            />
          }
          label="New Offer Letter (Added by Admin)"
        />
        <FormControlLabel
          control={
            <Checkbox
              name="notificationsToRecruiter"
              checked={settings.notificationsToRecruiter}
              sx={{
              color: "#333",
              "&.Mui-checked": {
                color: "#1d82f5",
              },
            }}
              onChange={handleChange}
            />
          }
          label="Notifications to Recruiter (Added by Admin)"
        />
      </Box>

      <Button
        variant="contained"
        color="primary"
        sx={{
          marginTop: "20px",
          backgroundColor: "#1d82f5",
          textTransform: "none",
          "&:hover": {
          backgroundColor: "orange", // Hover color
        },

        }}
        onClick={handleSave}
      >
        Save
      </Button>
    </Box>
  );
}
